export default __webpack_public_path__ + "static/media/hsa-faq.2e95f78d.svg";